import { useCallback, useState } from "react";
import { useRolPost } from "../../../fnx/rol/rolPost";
import { useRolPatch } from "../../../fnx/rol/rolPatch";
import { useDispatch } from "react-redux";
export var useCreateOrEditRol = function (rolId) {
    var dispatch = useDispatch();
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var _b = useState(false), triggerCreate = _b[0], setTriggerCreate = _b[1];
    var _c = useState(false), triggerEdit = _c[0], setTriggerEdit = _c[1];
    var _d = useState(undefined), rolFormData = _d[0], setRolFormData = _d[1];
    var _e = useRolPost(triggerCreate, rolFormData), responseRolPost = _e.responseRolPost, errorRolPost = _e.errorRolPost, loadingRolPost = _e.loadingRolPost;
    var _f = useRolPatch(triggerEdit, rolFormData, rolId), responseRolPatch = _f.responseRolPatch, errorRolPatch = _f.errorRolPatch, loadingRolPatch = _f.loadingRolPatch;
    var handleSubmitRol = useCallback(function (data) {
        setRolFormData(data);
        if (isEdit) {
            setTriggerEdit(true);
        }
        else {
            setTriggerCreate(true);
        }
    }, [isEdit]);
    var resetTriggers = useCallback(function () {
        setTriggerCreate(false);
        setTriggerEdit(false);
        setRolFormData(undefined);
    }, []);
    var setEditMode = useCallback(function (mode) {
        setIsEdit(mode);
    }, []);
    return {
        isEdit: isEdit,
        setIsEdit: setEditMode,
        handleSubmitRol: handleSubmitRol,
        resetTriggers: resetTriggers,
        loadingRolPost: loadingRolPost,
        loadingRolPatch: loadingRolPatch,
        errorRolPost: errorRolPost,
        errorRolPatch: errorRolPatch,
        response: isEdit ? responseRolPatch : responseRolPost,
    };
};
